import {defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {chempConstants, uriConstants} from "../../constants";

export const chempSendboxActions = {
  readSendboxList,
  readOrgSentList,
  changeSearchInfo,
  settingHistory,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 송신함 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: chempConstants.SELECT_SEARCH_REQUEST,
      payload: info
    }
  }
}


/*********
 송신함 리스트 조회
 **********/

function readSendboxList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )
    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CHEMP_OUTBOX_LIST + paramStr
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(alertActions.error({
                title: null,
                message: errorMessages.systemError
              }))
            }
        )
  }

  function request() {
    return {
      type: chempConstants.SENDBOX_REQUEST
    }
  }
  function success(response) {
    return {
      type: chempConstants.SENDBOX_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: chempConstants.SENDBOX_FAILURE,
      response
    }
  }
}

/*********
 송신함 원본 리스트 조회
 **********/

function readOrgSentList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CHEMP_OUTBOX_LIST + paramStr
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(alertActions.error({
                title: null,
                message: errorMessages.systemError
              }))
            }
        )
  }

  function request() {
    return {
      type: chempConstants.SENDBOX_ORG_REQUEST
    }
  }
  function success(response) {
    return {
      type: chempConstants.SENDBOX_ORG_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: chempConstants.SENDBOX_ORG_FAILURE,
      response
    }
  }
}

/***********
 증명서 송신함 리스트 히스토리관리
 ************/
function settingHistory(history) {
  return async dispatch => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: chempConstants.SENDBOX_HISTORY,
      payload: history
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}
